var map = {
	"./1001.svg": 1242,
	"./1002.svg": 1243,
	"./1003.svg": 1244,
	"./1004.svg": 1245,
	"./1005.svg": 1246,
	"./1006.svg": 1247,
	"./1007.svg": 1248,
	"./1008.svg": 1249,
	"./1009.svg": 1250,
	"./1011.svg": 1251,
	"./1013.svg": 1252,
	"./1014.svg": 1253,
	"./1015.svg": 1254,
	"./1016.svg": 1255,
	"./1017.svg": 1256,
	"./1018.svg": 1257,
	"./1019.svg": 1258,
	"./1021.svg": 1259,
	"./1022.svg": 1260,
	"./1023.svg": 1261,
	"./1024.svg": 1262,
	"./1025.svg": 1263,
	"./1026.svg": 1264,
	"./1027.svg": 1265,
	"./1028.svg": 1266,
	"./1029.svg": 1267,
	"./1030.svg": 1268,
	"./1031.svg": 1269,
	"./1032.svg": 1270,
	"./1033.svg": 1271,
	"./1034.svg": 1272,
	"./1035.svg": 1273,
	"./1036.svg": 1274,
	"./1037.svg": 1275,
	"./1038.svg": 1276,
	"./1039.svg": 1277,
	"./1040.svg": 1278,
	"./1041.svg": 1279,
	"./1042.svg": 1280,
	"./1043.svg": 1281,
	"./1044.svg": 1282,
	"./1045.svg": 1283,
	"./1046.svg": 1284,
	"./1047.svg": 1285,
	"./1048.svg": 1286,
	"./1049.svg": 1287,
	"./1050.svg": 1288,
	"./1051.svg": 1289,
	"./1052.svg": 1290,
	"./1053.svg": 1291,
	"./1054.svg": 1292,
	"./1055.svg": 1293,
	"./1056.svg": 1294,
	"./1057.svg": 1295,
	"./1058.svg": 1296,
	"./1059.svg": 1297,
	"./1060.svg": 1298,
	"./1061.svg": 1299,
	"./1062.svg": 1300,
	"./1063.svg": 1301,
	"./1064.svg": 1302,
	"./1065.svg": 1303,
	"./1066.svg": 1304,
	"./1067.svg": 1305,
	"./1068.svg": 1306,
	"./1069.svg": 1307,
	"./1070.svg": 1308,
	"./1071.svg": 1309,
	"./1072.svg": 1310,
	"./1073.svg": 1311,
	"./1074.svg": 1312,
	"./1075.svg": 1313,
	"./1076.svg": 1314,
	"./1077.svg": 1315,
	"./1078.svg": 1316,
	"./1079.svg": 1317,
	"./1080.svg": 1318,
	"./1081.svg": 1319,
	"./1082.svg": 1320,
	"./1083.svg": 1321,
	"./1084.svg": 1322,
	"./1085.svg": 1323,
	"./1086.svg": 1324,
	"./1087.svg": 1325,
	"./1100.svg": 1326,
	"./1101.svg": 1327,
	"./1102.svg": 1328,
	"./1103.svg": 1329,
	"./1104.svg": 1330,
	"./1105.svg": 1331,
	"./1106.svg": 1332,
	"./1107.svg": 1333,
	"./1108.svg": 1334,
	"./1109.svg": 1335,
	"./1111.svg": 1336,
	"./20.svg": 1337,
	"./2001.svg": 1338,
	"./2002.svg": 1339,
	"./2006.svg": 1340,
	"./2008.svg": 1341,
	"./201.svg": 1342,
	"./2010.svg": 1343,
	"./2011.svg": 1344,
	"./2012.svg": 1345,
	"./2013.svg": 1346,
	"./2014.svg": 1347,
	"./2015.svg": 1348,
	"./2016.svg": 1349,
	"./2017.svg": 1350,
	"./2018.svg": 1351,
	"./2019.svg": 1352,
	"./202.svg": 1353,
	"./2020.svg": 1354,
	"./2021.svg": 1355,
	"./2022.svg": 1356,
	"./2023.svg": 1357,
	"./2024.svg": 1358,
	"./2025.svg": 1359,
	"./2026.svg": 1360,
	"./2027.svg": 1361,
	"./2028.svg": 1362,
	"./2029.svg": 1363,
	"./203.svg": 1364,
	"./2030.svg": 1365,
	"./2031.svg": 1366,
	"./2032.svg": 1367,
	"./2033.svg": 1368,
	"./2034.svg": 1369,
	"./2035.svg": 1370,
	"./2036.svg": 1371,
	"./2037.svg": 1372,
	"./2038.svg": 1373,
	"./2039.svg": 1374,
	"./204.svg": 1375,
	"./2040.svg": 1376,
	"./2041.svg": 1377,
	"./2042.svg": 1378,
	"./2043.svg": 1379,
	"./2044.svg": 1380,
	"./2045.svg": 1381,
	"./2046.svg": 1382,
	"./2047.svg": 1383,
	"./2048.svg": 1384,
	"./2049.svg": 1385,
	"./205.svg": 1386,
	"./2050.svg": 1387,
	"./2051.svg": 1388,
	"./206.svg": 1389,
	"./207.svg": 1390,
	"./208.svg": 1391,
	"./209.svg": 1392,
	"./2099.svg": 1393,
	"./20v.svg": 1394,
	"./21.svg": 1395,
	"./210.svg": 1396,
	"./211.svg": 1397,
	"./212.svg": 1398,
	"./21v.svg": 1399,
	"./22.svg": 1400,
	"./22v.svg": 1401,
	"./23.svg": 1402,
	"./23v.svg": 1403,
	"./24.svg": 1404,
	"./24v.svg": 1405,
	"./25.svg": 1406,
	"./25v.svg": 1407,
	"./26.svg": 1408,
	"./26v.svg": 1409,
	"./28.svg": 1410,
	"./28v.svg": 1411,
	"./29.svg": 1412,
	"./291.svg": 1413,
	"./292.svg": 1414,
	"./293.svg": 1415,
	"./29v.svg": 1416,
	"./3003.svg": 1417,
	"./3004.svg": 1418,
	"./301.svg": 1419,
	"./3014.svg": 1420,
	"./3015.svg": 1421,
	"./3016.svg": 1422,
	"./3017.svg": 1423,
	"./3018.svg": 1424,
	"./3019.svg": 1425,
	"./302.svg": 1426,
	"./3020.svg": 1427,
	"./303.svg": 1428,
	"./304.svg": 1429,
	"./3099.svg": 1430,
	"./4001.svg": 1431,
	"./4003.svg": 1432,
	"./4008.svg": 1433,
	"./4009.svg": 1434,
	"./401.svg": 1435,
	"./4010.svg": 1436,
	"./4011.svg": 1437,
	"./4012.svg": 1438,
	"./4013.svg": 1439,
	"./4014.svg": 1440,
	"./4015.svg": 1441,
	"./4016.svg": 1442,
	"./4017.svg": 1443,
	"./4018.svg": 1444,
	"./4019.svg": 1445,
	"./402.svg": 1446,
	"./4020.svg": 1447,
	"./4021.svg": 1448,
	"./4022.svg": 1449,
	"./4023.svg": 1450,
	"./4024.svg": 1451,
	"./4025.svg": 1452,
	"./4026.svg": 1453,
	"./4027.svg": 1454,
	"./4028.svg": 1455,
	"./4029.svg": 1456,
	"./403.svg": 1457,
	"./404.svg": 1458,
	"./4099.svg": 1459,
	"./4100.svg": 1460,
	"./4101.svg": 1461,
	"./4102.svg": 1462,
	"./5006.svg": 1463,
	"./5007.svg": 1464,
	"./5008.svg": 1465,
	"./5009.svg": 1466,
	"./6001.svg": 1467,
	"./6008.svg": 1468,
	"./6010.svg": 1469,
	"./6011.svg": 1470,
	"./6012.svg": 1471,
	"./6099.svg": 1472,
	"./7014.svg": 1473,
	"./7015.svg": 1474,
	"./7016.svg": 1475,
	"./7017.svg": 1476,
	"./7018.svg": 1477,
	"./7019.svg": 1478,
	"./7020.svg": 1479,
	"./7021.svg": 1480,
	"./7022.svg": 1481,
	"./7099.svg": 1482,
	"./9001.svg": 1483,
	"./9002.svg": 1484,
	"./9003.svg": 1485,
	"./9004.svg": 1486,
	"./9005.svg": 1487,
	"./9006.svg": 1488,
	"./languages.svg": 1489,
	"./subjects.svg": 1490
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1241;